import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewEncapsulation,
} from '@angular/core';

import { TW_POPOVER_CONTEXT } from './tw-popover-context';

/**
 * `tw-popover-arrow` — optional pointer tying the popover visually
 * to its trigger (TWS-122 Wave 2).
 *
 * Rendered as a small `<div aria-hidden="true">` with a pseudo-
 * element triangle. Sized from design tokens (~8 px) and coloured
 * against the glass surface so it reads as an extension of the
 * panel edge.
 *
 * ### Arrow flip — deliberate simplification
 *
 * The arrow's rotation is keyed to the parent's *intended*
 * `placement`, NOT the post-`position-try-fallbacks` resolved
 * side. If the content auto-flips to avoid viewport overflow, the
 * arrow visually detaches from the content edge. Accepted
 * trade-off — proper arrow-tracking would require CSS `anchor()`
 * + position-try-fallback-aware arrow anchor-names (doable but
 * more layered than Wave 2 warrants). Revisit if the drift
 * becomes a visible UX issue in real usage.
 */
@Component({
  selector: 'tw-popover-arrow',
  standalone: true,
  template: '',
  styleUrls: ['./tw-popover.component.scss'],
  host: {
    'class': 'tw-popover__arrow',
    'aria-hidden': 'true',
    '[attr.data-placement]': 'ctx.placement()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TwPopoverArrowComponent {
  protected readonly ctx = inject(TW_POPOVER_CONTEXT);
}
